import { ManholeViewStore } from "../estimating/Manhole/stores/ManholeViewStore";
import {
  // IntraSyncDesignerViewStore,
  stackDesignerModule,
} from "@intrasync/stack-designer";
import JobListViewStore from "../estimating/JobManagement/JobListViewStore";
import JobDetailViewStore from "../estimating/JobManagement/JobDetailViewStore";

const estimatingStoresList = [
  { name: "manholeViewStore", store: ManholeViewStore },
  // { name: "intraSyncDesignerViewStore", store: IntraSyncDesignerViewStore },
  { name: "jobListViewStore", store: JobListViewStore },
  { name: "jobDetailViewStore", store: JobDetailViewStore },
  ...stackDesignerModule.viewStores,
];

export default estimatingStoresList;
